import styled from 'styled-components';

interface IPSW {
  background: string;
}
export const PageSectionWrapper = styled.div`
  box-sizing: border-box;
  min-height: 300px;
  padding: 18px 60px 18px 60px;
  width: 100%;
  background: ${(props: IPSW) => props.background};
  display: flex;
  justify-content: center;
`;
